import { render, staticRenderFns } from "./ConfirmarOrden.vue?vue&type=template&id=a916b6e8"
import script from "./ConfirmarOrden.vue?vue&type=script&lang=js"
export * from "./ConfirmarOrden.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarOrden.vue?vue&type=style&index=0&id=a916b6e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports